import React from 'react';
import './App.css';
import DojoApp from './dojo/DojoApp';

function App() {
  return <DojoApp />;
}

export default App;
